import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from './services/auth.service';

@Injectable()
export class NewTokenInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // return next.handle(req).pipe((e) => finalize((e) => this.responseInterceptor(e)));
    return next.handle(req).pipe(
      map((event: HttpEvent<any>) => {
        this.responseInterceptor(event);
        return event;
      })
    );
  }

  private responseInterceptor(event: HttpEvent<any>): void {
    // console.log('NewTokenInterceptor event', event);
    if (event instanceof HttpResponse && event.ok) {
      const token = event.headers.get('new-token');
      if (token) {
        const firstToken = token.split(',')[0].trim();
        this.authService.setToken(firstToken);
      }
    }
  }
}
